/**
 * Mock data for contacts module
 *
 * Data persists in-memory during the session (NO localStorage)
 */

// ============================================================
// INITIAL MOCK DATA (read-only templates)
// ============================================================

const INITIAL_CONTACTS = [
  {
    id: 1,
    first_name: "Mario",
    last_name: "Rossi",
    email: "mario.rossi@example.com",
    phone: "+39 333 1234567",
    company: "ACME S.p.A.",
    position: "CEO",
    notes: "Contatto principale per la trattativa Q1",
    created_at: "2026-01-15T10:30:00Z",
    updated_at: "2026-01-25T14:20:00Z",
  },
  {
    id: 2,
    first_name: "Laura",
    last_name: "Bianchi",
    email: "laura.bianchi@techcorp.it",
    phone: "+39 340 9876543",
    company: "TechCorp Italia",
    position: "CTO",
    notes: "Interessata a soluzioni cloud",
    created_at: "2026-01-18T09:15:00Z",
    updated_at: "2026-01-28T11:45:00Z",
  },
  {
    id: 3,
    first_name: "Giuseppe",
    last_name: "Verdi",
    email: "g.verdi@innovatech.com",
    phone: "+39 348 5551234",
    company: "InnovaTech",
    position: "Project Manager",
    notes: "",
    created_at: "2026-01-20T16:00:00Z",
    updated_at: "2026-01-20T16:00:00Z",
  },
];

// ============================================================
// IN-MEMORY STATE (mutable during session)
// ============================================================

let contactsState = JSON.parse(JSON.stringify(INITIAL_CONTACTS)); // Deep clone

// Track next ID for creating new entities
let nextContactId = Math.max(...INITIAL_CONTACTS.map(c => c.id), 0) + 1;

// ============================================================
// STATE ACCESSORS & MUTATORS
// ============================================================

/**
 * Get current contacts state
 * @returns {Array}
 */
export const getContactsState = () => contactsState;

/**
 * Set contacts state
 * @param {Array} newContacts
 */
export const setContactsState = (newContacts) => {
  contactsState = newContacts;
};

/**
 * Get and increment next contact ID
 * @returns {number}
 */
export const getNextContactId = () => {
  return nextContactId++;
};

/**
 * Reset all state to initial values (useful for testing)
 */
export const resetMockData = () => {
  contactsState = JSON.parse(JSON.stringify(INITIAL_CONTACTS));
  nextContactId = Math.max(...INITIAL_CONTACTS.map(c => c.id), 0) + 1;
};
